import { render, staticRenderFns } from "./systemArticle.vue?vue&type=template&id=2626a05f&scoped=true&"
import script from "./systemArticle.vue?vue&type=script&lang=js&"
export * from "./systemArticle.vue?vue&type=script&lang=js&"
import style0 from "./systemArticle.vue?vue&type=style&index=0&id=2626a05f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2626a05f",
  null
  
)

export default component.exports